module.exports = __webpack_public_path__ + "static/media/thick-line-horizontal.752f49df.svg";